import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11,
  _t12,
  _t13,
  _t14,
  _t15,
  _t16,
  _t17,
  _t18,
  _t19,
  _t20,
  _t21;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import * as dayjs from 'dayjs';
import 'dayjs/locale/lb';
import Flickity from 'flickity';
import { html, LitElement } from 'lit';
import { helper } from "../../common/helper";
import PlayRepository from './PlayRepository.js';
import css from './style.pcss';
import RtlGoldCircleImage from "./images/circle-rtl-gold.png";
import FlagAudioIcon from "./images/ic_flag_audio.svg";
import FlagVideoIcon from "./images/ic_flag_video.svg";
import VideoIconRtlGold from "./images/ic_video_rtl-gold.svg";
import PlayOutlineImage from "../../common/images/logo_rtlplay.svg";
import WatchButtonImage from "../../common/images/btn_watch.svg";
var MediaFlagIcons = {
  "audio": FlagAudioIcon,
  "video": FlagVideoIcon
};
var RTLPlaySlider = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLPlaySlider, _LitElement);
  function RTLPlaySlider() {
    var _this;
    _classCallCheck(this, RTLPlaySlider);
    _this = _callSuper(this, RTLPlaySlider);
    _this.emissions = [];
    _this.episodes = [];
    _this.highlights = [];
    _this.language = 'lb';
    _this.isApp = false;
    _this.currentApp = '';
    _this.prefix = '';
    _this.emissionTitle = '';
    _this.emission = '';
    _this.showDate = false;
    _this.layout = 'default'; // Default / Radio
    _this.covertype = 'default';
    _this.tag = '';
    _this.showLayout = false;
    if (window.rtlsites) {
      _this.isApp = window.rtlsites.config.isApp;
      _this.currentApp = window.rtlsites.config.currentApp;
      if (window.rtlsites.config.language !== 'lu') _this.language = window.rtlsites.config.language;
    }
    if (_this.isApp) {
      _this.prefix = _this.currentApp + '://safari/';
    }
    return _this;
  }
  _createClass(RTLPlaySlider, [{
    key: "createRenderRoot",
    value: function createRenderRoot() {
      return this;
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLPlaySlider.prototype), "connectedCallback", this).call(this);
      this.repo = new PlayRepository(this.language);
      this._fetchData();
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      if (this.type === 'emissions') {
        if (this.emissionslug) {
          this.repo.getEmissionsBySlug(this.emissionslug).then(function (resp) {
            _this2.emissions = resp.emissions;
          });
        } else if (this.tag) {
          this.repo.getEmissionsByTag(this.tag).then(function (resp) {
            _this2.emissions = resp.emissions;
          });
        } else {
          this.repo.getEmissions().then(function (resp) {
            _this2.emissions = resp.emissions;
          });
        }
      } else if (this.type === 'collection') {
        if (this.collectionslug) {
          this.repo.getByCollection(this.collectionslug, this.limit).then(function (resp) {
            _this2.episodes = resp.episodes;
          });
        }
      } else if (this.type === 'episodes') {
        if (this.emissionslug) {
          this.repo.getEpisodes(this.emissionslug, this.limit).then(function (resp) {
            _this2.episodes = resp.episodes;
          });
          this.repo.getEmission(this.emissionslug).then(function (resp) {
            _this2.emissionTitle = resp.name;
            _this2.emission = resp;
          });
        }
      } else {
        this.repo.getHighlights().then(function (resp) {
          _this2.highlights = resp.highlights;
        });
      }
    }
  }, {
    key: "renderEmissionCard",
    value: function renderEmissionCard(emission) {
      var _this3 = this;
      if (this.type !== 'emissions') return;
      var mediaFlagClasses = {
        audio: 'rtl-play-box__flags-audio',
        video: 'rtl-play-box__flags-video'
      };
      var emissionUrl = `${this.prefix}https://play.rtl.lu/shows/${emission.lang}/${emission.id}/episodes`;
      return html(_t || (_t = _`<div class="slider__item">
                        <a class="rtl-play-box__emission-link" target="_blank" @click=${0}>
                            <div class="rtl-play-box__emission-img-container">
                                ${0}
                                ${0}
                                ${0}
                                ${0}
                            </div>

                            <div class="rtl-play-box__languages-container">
                                ${0}
                            </div>

                            <div class="rtl-play-box__flags">
                                ${0}
                            </div>
                        </a>
                    </div>`), function (e) {
        return _this3._handleClick(e, emissionUrl, emission._links.app);
      }, this.covertype === 'portrait' ? html(_t2 || (_t2 = _`<img class="rtl-play-box__emission-img" src="${0}" />`), `${helper.stockify(emission.covers.portrait, 500)}`) : '', this.covertype === 'landscape' ? html(_t3 || (_t3 = _`<img class="rtl-play-box__emission-img" src="${0}" />`), `${helper.stockify(emission.covers.landscape, 500)}`) : '', this.covertype === 'square' ? html(_t4 || (_t4 = _`<img class="rtl-play-box__emission-img" src="${0}" />`), `${helper.stockify(emission.covers.square, 500)}`) : '', this.covertype === 'default' ? html(_t5 || (_t5 = _`<img class="rtl-play-box__emission-img" src="${0}" />`), `${helper.stockify(emission.covers.landscape, 500)}`) : '', emission.languages.map(function (language) {
        return html(_t6 || (_t6 = _`<div class="rtl-play-box__languages">${0}</div>`), language === 'lb' ? 'LU' : language);
      }), emission.media_flags.filter(function (f) {
        return ['audio', 'video'].includes(f);
      }).map(function (mediaFlag) {
        return html(_t7 || (_t7 = _`<div class="${0}">
                                            <img class="rtl-play-box__flags-img" src="${0}"/>
                                        </div>`), mediaFlagClasses[mediaFlag], MediaFlagIcons[mediaFlag]);
      }));
    }
  }, {
    key: "renderSimpleEmissionCard",
    value: function renderSimpleEmissionCard(emission) {
      var _this4 = this;
      if (this.type !== 'emissions') return;
      if (!emission._links) return;
      var emissionUrl = `${this.prefix}https://play.rtl.lu/shows/${emission.lang}/${emission.id}/episodes`;
      var appUrl = `rtlluplay://emissions/${emission.lang}/${emission.slug}`;
      return html(_t8 || (_t8 = _`<div class="rtl-play-box-slide slider__item rtl-play-box-slide--${0}">
                        <a class="rtl-play-box-slide__link" @click=${0}>
                            <div class="rtl-play-box-slide__image-container">
                                ${0}
                                ${0}
                            </div>
                        </a>
                    </div>`), this.layout, function (e) {
        return _this4._handleClick(e, emissionUrl, emission._links.app);
      }, this.covertype === 'square' ? html(_t9 || (_t9 = _`<img class="rtl-play-box-slide__image" src="${0}" />`), `${helper.stockify(emission.covers.square, 500)}`) : '', this.covertype === 'default' ? html(_t10 || (_t10 = _`<img class="rtl-play-box-slide__image" src="${0}" />`), `${helper.stockify(emission.covers.portrait, 500)}`) : '');
    }
  }, {
    key: "renderHighlightCard",
    value: function renderHighlightCard(highlight) {
      var _this5 = this;
      if (this.type !== 'highlights') return;
      var baseUrl = 'https://play.rtl.lu';
      if (highlight._links.web.indexOf('https://play.rtl.lu') !== -1) baseUrl = '';
      var emissionUrl = `${this.prefix}${baseUrl}${highlight._links.web}`;
      return html(_t11 || (_t11 = _`<div class="slider__item">
                        <a class="rtl-play-box__highlights-link" @click=${0}>
                            <div class="rtl-play-box__highlights-img-container">
                                <div class="rtl-play-box__highlights-img-gradient"></div>
                                <img class="rtl-play-box__highlights-img" src="${0}" />
                                <div class="rtl-play-box__highlights-details">
                                <img class="rtl-play-box__highlights-logo" src="${0}" />
                                </div>
                            </div>
                            <div class="rtl-play-box__highlights-text">
                                ${0}
                            </div>
                        </a>
                    </div>`), function (e) {
        return _this5._handleClick(e, emissionUrl, highlight._links.app);
      }, helper.stockify(highlight.images.landscape, 700), helper.stockify(highlight.logo, 300), highlight.description);
    }
  }, {
    key: "renderEpisodeCard",
    value: function renderEpisodeCard(episode) {
      var _this6 = this;
      if (this.type !== 'episodes' && this.type !== 'collection') return;
      if (!episode._links) return;
      var emissionUrl = `${this.prefix}https://play.rtl.lu${episode._links.web}`;
      return html(_t12 || (_t12 = _`<div class="slider__item slider__item--${0}">
                        <a class="rtl-play-box__highlights-link" @click=${0}>
                            <div class="rtl-play-box__highlights-img-container">
                                <div class="rtl-play-box__highlights-img-gradient"></div>
                                <img class="rtl-play-box__highlights-img" src="${0}" />
                            </div>
                            <div class="rtl-play-box__highlights-details">
                                <div class="rtl-play-box__highlights-name">
                                    ${0}
                                </div>
                                <div class="rtl-play-box__highlights-date">
                                    ${0}
                                </div>
                                <div class="rtl-play-box__highlights-text">
                                    ${0}
                                </div>
                            </div>
                        </a>
                    </div>`), this.layout, function (e) {
        return _this6._handleClick(e, emissionUrl, episode._links.app);
      }, helper.stockify(episode.thumbnail, 700), episode.name, dayjs(episode.date).format('DD/MM/YYYY'), episode.description);
    }
  }, {
    key: "renderSimpleEpisodeCard",
    value: function renderSimpleEpisodeCard(episode) {
      var _this7 = this;
      if (this.type !== 'episodes') return;
      var emissionUrl = `${this.prefix}https://play.rtl.lu${episode._links.web}`;
      return html(_t13 || (_t13 = _`<div class="rtl-play-box-slide slider__item rtl-play-box-slide--${0}">
                        <a class="rtl-play-box-slide__link" @click=${0}>
                            <div class="rtl-play-box-slide__image-container">
                                <img class="rtl-play-box-slide__image" src="${0}" />
                            </div>
                            <div class="rtl-play-box-slide__content">
                                <div class="rtl-play-box-slide__name">
                                    ${0}
                                </div>
                                <div class="rtl-play-box-slide__date">
                                    ${0}
                                </div>
                            </div>
                        </a>
                    </div>`), this.layout, function (e) {
        return _this7._handleClick(e, emissionUrl, episode._links.app);
      }, helper.stockify(episode.thumbnail, 300), episode.name, dayjs(episode.date).format('DD/MM/YYYY'));
    }
  }, {
    key: "renderHeaderTitle",
    value: function renderHeaderTitle() {
      if (this.type === 'episodes') {
        return html(_t14 || (_t14 = _`
                <div class="rtl-play-box__title-emissions">
                    ${0}
                </div>`), this.emissionTitle);
      }
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      if (this.showRtlGoldHeader) {
        return html(_t15 || (_t15 = _`
            <div class="rtl-play-box__header-content">
                <div class="rtl-play-box__header">
                    <img class="rtl-play-box__header-img" src="${0}" alt="Logo RTL PLay"/>
                    <a class="block-link__overlay" href="${0}https://play.rtl.lu" target="_blank"></a>
                </div>

                <div class="rtl-play-box__btn-rtl-gold btn-rtl-gold ">
                    <img class="btn-rtlgold__logo" src="${0}" alt="Logo RTL GOLD"/>
                    <p class="btn-rtlgold__text">De Radio fir Retro Fans</p>
                    <img class="btn-rtlgold__icon" src="${0}" alt="Icon play"/>
                    <a class="block-link__overlay" href="${0}https://play.rtl.lu/live/rtl-gold" target="_blank"></a>
                </div>
            </div>`), PlayOutlineImage, this.prefix, RtlGoldCircleImage, VideoIconRtlGold, this.prefix);
      }

      //console.log(this.emission);

      if (this.showLayout && this.emission._links) {
        return html(_t16 || (_t16 = _`
                <div class="rtl-play-box__header-container">
                    <div class="rtl-play-box__header-show">
                        <a href="https://play.rtl.lu/${0}" target="_blank">${0}</a>
                    </div>
                </div>
            `), this.emission._links.web, this.emission.highlight.name);
      }
      return html(_t17 || (_t17 = _`<div class="rtl-play-box__header-container">
            <a href="${0}https://play.rtl.lu" target="_blank"><img class="rtl-play-box__header-img" src="${0}" alt="Logo RTL PLay"/></a>
        </div>`), this.prefix, PlayOutlineImage);
    }
  }, {
    key: "renderDefault",
    value: function renderDefault(className, emissions, highlights, episodes) {
      var _this8 = this;
      return html(_t18 || (_t18 = _`
            <div class="${0}">
                ${0}
                <div class="slider slider--rtl-play slider--rtl-play-box">
                    ${0}
                    ${0}
                    ${0}
                </div>
            </div>
        `), className, this.renderHeader(), emissions.map(function (emission) {
        return _this8.renderEmissionCard(emission);
      }), highlights.map(function (highlight) {
        return _this8.renderHighlightCard(highlight);
      }), episodes.map(function (episodes) {
        return _this8.renderEpisodeCard(episodes);
      }));
    }
  }, {
    key: "renderNoCoporate",
    value: function renderNoCoporate(className, episodes, emission, emissions) {
      var _this9 = this;
      if (this.type === 'emissions') {
        return html(_t19 || (_t19 = _`
                <style>${0}</style>
                <div class="${0}">
                    <div class="rtl-play-box__slider slider slider--rtl-play slider--rtl-play-box">
                        ${0}
                    </div>
                </div>
            `), css, className, emissions.map(function (emission) {
          return _this9.renderSimpleEmissionCard(emission);
        }));
      }
      return html(_t20 || (_t20 = _`
            <style>${0}</style>
            <div class="${0}">
                ${0}
                <div class="rtl-play-box__slider slider slider--rtl-play slider--rtl-play-box">
                    ${0}
                </div>
            </div>
        `), css, className, emission ? html(_t21 || (_t21 = _`
                    <div class="rtl-play-box__cover rtl-play-box__cover--square">
                        <a @click=${0} target="_blank"><img class="rtl-play-box__cover-img" src="${0}" width="250" alt="${0}" /></a>
                    </div>
                    <div class="rtl-play-box__title">
                        ${0}
                    </div>
                `), function (e) {
        return _this9._handleClick(e, `https://play.rtl.lu/shows/${emission.lang}/${emission.id}`);
      }, helper.stockify(emission.covers.square, 500), emission.name, emission.name) : '', episodes.map(function (episodes) {
        return _this9.renderSimpleEpisodeCard(episodes);
      }));
    }
  }, {
    key: "_handleClick",
    value: function _handleClick(e, url, appurl) {
      helper.openPlayLink(url, appurl);
    }
  }, {
    key: "render",
    value: function render() {
      var _this10 = this;
      if (this.type === 'emissions' && (this.emissions == undefined || this.emissions.length == 0)) return;
      if (this.type === 'highlights' && (this.highlights == undefined || this.highlights.length == 0)) return;
      if (this.type === 'episodes' && (this.episodes == undefined || this.episodes.length == 0)) return;
      if (this.type === 'collection' && (this.episodes == undefined || this.episodes.length == 0)) return;
      if (this.type === 'episodes' && !this.emission) return;
      this.updateComplete.then(function () {
        if (!_this10.flickity) {
          var slider = _this10.querySelector('.slider');
          _this10.flickity = new Flickity(slider, {
            groupCells: true,
            wrapAround: false,
            pageDots: true,
            cellAlign: _this10.type === 'emissions' || _this10.type === 'episodes' ? 'left' : 'center',
            contain: true,
            adaptiveHeight: true,
            lazyLoad: true,
            draggable: true
          });
        }
      });
      var emissions = this.emissions;
      var episodes = this.episodes;
      var highlights = this.highlights;
      var emission = this.emission;
      var boxClass = '';
      if (this.emissionsSlug) boxClass = `rtl-play-box--${this.emissionslug}`;
      if (this.tag) boxClass = `rtl-play-box--${this.tag}`;
      var className = `rtl-play-box rtl-play-box__container rtl-play-box--${this.type} rtl-play-box--${this.layout} ${boxClass}`;
      if (this.showLayout) className += ' rtl-play-box__show-layout';
      switch (this.layout) {
        case 'nocorporate':
          return this.renderNoCoporate(className, episodes, emission, emissions);
        default:
          return this.renderDefault(className, emissions, highlights, episodes);
      }
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        limit: {
          type: String
        },
        language: {
          type: String
        },
        type: {
          type: String
        },
        emissions: {
          type: Array
        },
        episodes: {
          type: Array
        },
        emissionslug: {
          type: String
        },
        highlights: {
          type: Array
        },
        hideHeader: {
          type: Boolean
        },
        prefix: {
          type: String
        },
        emissionTitle: {
          type: String
        },
        showRtlGoldHeader: {
          type: Boolean
        },
        showDate: {
          type: Boolean
        },
        showLayout: {
          type: Boolean
        },
        layout: {
          type: String
        },
        covertype: {
          type: String
        },
        tag: {
          type: String
        },
        isApp: {
          type: Boolean
        },
        currentApp: {
          type: String
        },
        collectionslug: {
          type: String
        }
      };
    }
  }]);
  return RTLPlaySlider;
}(LitElement);
export { RTLPlaySlider as default };
window.customElements.define('rtl-play-slider', RTLPlaySlider);